
<ion-content>

  <ion-menu-toggle class="SCWEB-menu-icon">
    <ion-button color="white">
      <img src="assets/img/shortcut-icon.png" class="SCWEB-menu-img"/>
    </ion-button>
  </ion-menu-toggle>

  <div class="SCWEB-address-container" (click)="openAddress($event)">
    <p>{{userService.user ?
        (userService.user.address ? (userService.user.address | addressShort) : 'Select an address')
        : 'Select an address'}}</p>
    <ion-icon name="md-create"></ion-icon>
  </div>

  <div class="top-section">
    <p class="filters-header">
      Filter your results
    </p>
    <h2 class="filters-text">
      I want <span (click)="openServices()" class="bold-underline">{{ apptCreator.mainScreenSelectedServiceTypeList.longText }}</span> for <span (click)="openDateSelector($event)" class="bold-underline">{{ apptCreator.mainScreenSelectedWeek.text }}</span>.
    </h2>
  </div>

  <div class="pro-section">

    <div *ngFor="let screenItem of screenItems">

      <div *ngIf="screenItem.type == 'concierge-chat-banner'" class="banner-container clickable-banner" (click)="conciergeChatFromBanner()">
        <!-- Unavailable in area banner -->
        <img [src]="screenItem.icon" class="banner-img"/>
        <p class="title">{{screenItem.action}}
          <ion-icon class="right-icon" name="chevron-forward-outline" slot="end"></ion-icon>
        </p>
        <p class="description">
          {{screenItem.description}}
        </p>
      </div>

      <div *ngIf="screenItem.type == 'text-banner' && screenItem.id == 'welcome'" class="banner-container welcome-banner">
        <!-- Unavailable in area banner -->
        <img src="assets/img/shortcut-icon.png" class="banner-img"/>
        <p class="title" [innerHTML]="screenItem.htmlText"></p>
      </div>

      <div *ngIf="screenItem.type == 'text-banner' && screenItem.id == 'business-banner'" class="banner-container welcome-banner business-banner">
        <!-- Business banner -->
        <img [src]="screenItem.webIcon || 'assets/img/shortcut-icon.png'" class="banner-img rounded"/>
        <p class="title" [innerHTML]="screenItem.htmlText"></p>
      </div>

      <div *ngIf="screenItem.type == 'text-banner' && screenItem.id == 'unavailable'" class="banner-container">
        <!-- Unavailable in area banner -->
        <ion-icon class="left-icon" name="information-circle-outline" color="red"></ion-icon>
        <p class="title">{{screenItem.title}}</p>
      </div>

      <div *ngIf="screenItem.type == 'rebook-banner'" class="banner-container clickable-banner" (click)="goToBarber(screenItem.barberLink, 'Main Screen', null, undefined)">
        <!-- Unavailable in area banner -->
        <img [src]="screenItem.icon" class="banner-img"/>
        <p class="title">{{screenItem.action}}
          <ion-icon class="right-icon" name="chevron-forward-outline" slot="end"></ion-icon>
        </p>
        <p class="description">
          {{screenItem.description}}
        </p>
      </div>

      <div *ngIf="screenItem.type == 'join-event-banner'" class="banner-container clickable-banner" (click)="joinEvent(screenItem.eventID)">
        <!-- Unavailable in area banner -->
        <img src="assets/img/shortcut-icon.png" class="banner-img"/>
        <p class="title">{{screenItem.action}}
          <ion-icon class="right-icon" name="chevron-forward-outline" slot="end"></ion-icon>
        </p>
        <p class="description">
          {{screenItem.description}}
        </p>
      </div>

      <div *ngIf="screenItem.type == 'url-text-banner'" class="banner-container clickable-banner" (click)="openURL(screenItem.url)">
        <!-- Unavailable in area banner -->
        <img src="assets/img/shortcut-icon.png" class="banner-img"/>
        <p class="title">{{screenItem.action}}
          <ion-icon class="right-icon" name="chevron-forward-outline" slot="end"></ion-icon>
        </p>
        <p class="description">
          {{screenItem.description}}
        </p>
      </div>

      <div *ngIf="screenItem.type == 'button-group' && screenItem.id == 'unavailable-buttons'" class="unavailable-buttons">
        <!-- Unavailable in area buttons -->
        <span *ngFor="let button of screenItem.buttons" >
          <div *ngIf="isRecognizedButton(button)" class="button-group-button" (click)="handleButtonGroupPressed(button)">
            <div class="text-container">
              <p class="title" [ngClass]="button.description ? 'bold' : ''">{{ button.text }}</p>
              <p class="description" *ngIf="button.description">{{ button.description }}</p>
            </div>
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </div>
        </span>
      </div>

      <div class="card-group-w-header featured-card-group" *ngIf="screenItem.isFeaturedCardGroup &&(screenItem.type === 'barber-group' || screenItem.type === 'day-segment-group')">

        <h3 class="title"> {{screenItem.title}} </h3>
        <p class="subtitle"> {{screenItem.subtitle}} </p>

        <div class="barber-cards">
          <ion-card class="barber-card" *ngFor="let avail of screenItem.showingAvails" (click)="goToBarber(avail.barber.link, 'Main Screen', null, avail.canBook)">

            <ion-card-content class="barber-card-content">

              <div class="col-barber-img">
                <img [src]="avail.barber.imgURL" class="barber-img"/>
              </div>

              <div class="col-barber-info">
                <h4 class="first-name"> {{avail.barber.firstName}} </h4>
                <h4 class="last-name"> {{avail.barber.lastName}} </h4>
                <p class="city-state-with-distance"> {{avail.barber.cityStateWithDistance}} </p>
              </div>

              <div class="salon-image">
                <img [src]="avail.barber.businessPic || 'assets/img/shortcut-icon.png'" />
              </div>

              <div class="barber-stars">
                <ion-icon name="star" class="SC-star-icon" [ngClass]="avail.barber.numRatings <= 3 ? 'stars-less-opaque' : ''" *ngFor="let _ of toRange(roundedRating(avail.barber.rating))"></ion-icon>
                <span class="rating-label marine">{{roundToTwo(avail.barber.rating, true)}}</span>
                <span class="rating-label" *ngIf="avail.barber.numRatings > 5">({{avail.barber.numRatings}})</span>
                <span class="rating-label gold" *ngIf="avail.barber.numRatings <= 5">{{avail.barber.availableToBook ? '(Book now)' : '(Coming soon)'}}</span>
              </div>

              <div class="barber-services-and-photos">
                <div class="barber-services">
                  <p>
                    {{avail.barber.serviceCategories.join(', ')}}
                  </p>
                </div>
                <div class="barber-photos">
                  <img class="barber-photo" *ngFor="let thumbURL of avail.barber.featuredImageThumbs" [src]="thumbURL" />
                </div>
              </div>


              <div class="card-bottom">
                <div *ngIf="!avail.availableTimes || !avail.availableTimes.length">
                  <ion-button *ngIf="avail.barber.availableToBookNow" fill="outline" class="action-button">
                    <ion-icon name="flash" color="gold"></ion-icon>
                    Book now with {{avail.barber.firstName}}
                  </ion-button>
                  <ion-button *ngIf="!avail.barber.availableToBookNow" fill="outline" class="action-button">
                    <ion-icon name="chatbubbles" color="chatblue"></ion-icon>
                    Chat to book with {{avail.barber.firstName}}
                  </ion-button>
                </div>
                <div class="timeslots" *ngIf="avail.availableTimes && avail.availableTimes.length">
                  <ion-card *ngFor="let timeString of avail.availableTimes" class="time-card" (click)="goToBarber(avail.barber.link, 'Main Screen', stringToDate(timeString), avail.canBook)">
                    <ion-card-content>
                      <p class="timeslot-date">{{ getAdjustedDisplayDate(stringToDate(timeString), avail.timezoneOffset) }}</p>
                      <p>{{ getAdjustedDisplayTime(stringToDate(timeString), avail.timezoneOffset) }}</p>
                    </ion-card-content>
                  </ion-card>
                </div>
              </div>

            </ion-card-content>
          </ion-card>

          <p class="show-more-button" *ngIf="screenItem.avails.length !== screenItem.showingAvails.length" (click)="showMoreAvails(screenItem)">
            View more ({{screenItem.avails.length - screenItem.showingAvails.length}})
            <ion-icon name="chevron-down-outline" class="dropdown-arrow"></ion-icon>
          </p>
        </div>

      </div>

      <div class="card-group-w-header" *ngIf="!screenItem.isFeaturedCardGroup &&(screenItem.type === 'barber-group' || screenItem.type === 'day-segment-group')">

        <h3 class="title"> {{screenItem.title}} </h3>
        <p class="subtitle"> {{screenItem.subtitle}} </p>
        <p *ngIf="screenItem.groupProType && screenItem.groupProType !== userService.user.currentProType" class="subtitle view-all-pro-type" (click)="switchProType(screenItem.groupProType)">View all {{screenItem.groupProType}} Pros</p>

        <div class="barber-cards">
          <ion-card class="barber-card" *ngFor="let avail of screenItem.showingAvails" (click)="goToBarber(avail.barber.link, 'Main Screen', null, avail.canBook)">

            <ion-card-content class="barber-card-content">

              <div class="col-barber-img">
                <img [src]="avail.barber.imgURL" class="barber-img"/>
              </div>

              <div class="col-barber-info">
                <h4> {{avail.barber.name}} </h4>

                <div class="barber-stars">
                  <ion-icon name="star" class="SC-star-icon" [ngClass]="avail.barber.numRatings <= 3 ? 'stars-less-opaque' : ''" *ngFor="let _ of toRange(roundedRating(avail.barber.rating))"></ion-icon>

                  <span class="rating-label" *ngIf="avail.barber.numRatings > 5">({{avail.barber.numRatings}})</span>
                  <span class="rating-label gold" *ngIf="avail.barber.numRatings <= 5">{{avail.barber.availableToBook ? '(Book now)' : '(Coming soon)'}}</span>
                </div>
              </div>

              <div class="pin-text">
                <div class="works-from-home-container" *ngIf="avail.barber.acceptOnlyCustomAddress">
                    <ion-icon name="home"></ion-icon>
                    <span>Works at home</span>
                </div>

                <span>
                  {{avail.barber.distanceText}}
                </span>
                <ion-icon name="navigate-circle-outline"></ion-icon>
              </div>

              <div *ngIf="screenItem.type == 'barber-group'" class="card-bottom">
                <div class="recent-curated-review" *ngIf="avail.barber.featuredReview">
                  <img src="assets/img/quote.png" class="quote-img"/>
                  <p class="recent-quote">{{avail.barber.featuredReview}} <span class="quoter">– {{avail.barber.featuredReviewFirstName}}</span></p>
                </div>
                <div *ngIf="!avail.barber.featuredReview">
                  <ion-button *ngIf="avail.barber.availableToBookNow" fill="outline" class="action-button">
                    <ion-icon name="flash" color="gold"></ion-icon>
                    Book now with {{avail.barber.firstName}}
                  </ion-button>
                  <ion-button *ngIf="!avail.barber.availableToBookNow" fill="outline" class="action-button">
                    <ion-icon name="chatbubbles" color="chatblue"></ion-icon>
                    Chat to book with {{avail.barber.firstName}}
                  </ion-button>
                </div>
              </div>

              <div *ngIf="screenItem.type == 'day-segment-group'" class="card-bottom">
                <div class="timeslots" *ngIf="avail.availableTimes && avail.availableTimes.length">
                  <ion-card *ngFor="let timeString of avail.availableTimes" class="time-card" (click)="goToBarber(avail.barber.link, 'Main Screen', stringToDate(timeString), avail.canBook)">
                    <ion-card-content>
                      <p>{{ getAdjustedDisplayTime(stringToDate(timeString), avail.timezoneOffset) }}</p>
                    </ion-card-content>
                  </ion-card>
                </div>
                <div *ngIf="!avail.availableTimes || !avail.availableTimes.length">
                  <ion-button *ngIf="avail.barber.availableToBookNow" fill="outline" class="action-button">
                    <ion-icon name="flash" color="gold"></ion-icon>
                    Book now with {{avail.barber.firstName}}
                  </ion-button>
                  <ion-button *ngIf="!avail.barber.availableToBookNow" fill="outline" class="action-button">
                    <ion-icon name="chatbubbles" color="chatblue"></ion-icon>
                    Chat to book with {{avail.barber.firstName}}
                  </ion-button>
                </div>
              </div>

            </ion-card-content>
          </ion-card>

          <p class="show-more-button" *ngIf="screenItem.avails.length !== screenItem.showingAvails.length" (click)="showMoreAvails(screenItem)">
            View more ({{screenItem.avails.length - screenItem.showingAvails.length}})
            <ion-icon name="chevron-down-outline" class="dropdown-arrow"></ion-icon>
          </p>
        </div>

      </div>
    </div>

  </div>

  <div class="SC-empty-state-div" [hidden]="emptyStateNoLocation || (screenItems && screenItems.length > 0)">
    <ion-spinner class="SC-empty-state-spinner" [hidden]="errorString"></ion-spinner>
    <p  *ngIf="userService.user" class="SC-empty-state-text" [hidden]="errorString">Finding your {{userService.user.currentProType}} Pro...</p>
    <p class="SC-empty-state-text" [hidden]="!errorString">{{errorString}}</p>
  </div>

  <div class="SC-empty-state-div" *ngIf="emptyStateNoLocation && userService.user && userService.user.address">
    <ion-icon name="map" class="SC-empty-state-icon"></ion-icon>
    <p class="SC-empty-state-text">Could not load location information. Please try again.</p>
    <p class="SC-empty-state-action SC-clickable" (click)="pullContent()">REFRESH</p>
  </div>

  <div class="SC-empty-state-div" *ngIf="emptyStateNoLocation && (!userService.user || !userService.user.address)">
    <ion-icon name="map" class="SC-empty-state-icon"></ion-icon>
    <p class="SC-empty-state-text">Type your address to view nearby Pros.</p>
    <p class="SC-empty-state-action SC-clickable" (click)="openAddress($event)">ENTER ADDRESS</p>
  </div>

</ion-content>
